import api from "@/axiosSetup";


export function backupUsersBookedDay(dayId, usersBooked) {
        const config = {
        headers: {
                'Content-Type': 'application/json', // Set the content type based on your data
                'Access-Control-Allow-Origin': '*', // Set the origin that's allowed
        },
        };
        api.patch(`/api/days-backup-users/${dayId}`, { usersBooked }, config);
        // const data = response.data.usersBooked;
        // return data;
        // console.log("Days updated!", data);
}

// GET NEXT DIVS
  //// const firstDay = document.querySelector(`div.day[data-date="${activeDates[0]}"]`);
                // const adjacentDivs = [];
                // let currentDiv = firstDay;
                // for (let i = 0; i < 6; i++) {
                //     currentDiv = currentDiv.nextElementSibling; //gets next
                //     //check if there is a next sibling and if it's a div
                //     if (currentDiv && currentDiv.classList.contains('day') 
                //         && !currentDiv.classList.contains('prev-date')
                //         && !currentDiv.classList.contains('next-date')) 
                //     {
                //         adjacentDivs.push(currentDiv);
                //     } else {
                //         break;
                //     }
                // }


//BACKUP MONTHS
// const currentDate = new Date();
        // const currentMonth = currentDate.getMonth() + 1; //1-12
        // console.log(currentMonth);
        // if (currentMonth === 1 || currentMonth === 2) {
        //     setStartingMonth(0);
        // }
        // if (currentMonth === 3 || currentMonth === 4) {
        //     setStartingMonth(2);
        // }
        // if (currentMonth === 5 || currentMonth === 6) {
        //     setStartingMonth(4);
        // }
        // if (currentMonth === 7 || currentMonth === 8) {
        //     setStartingMonth(6);
        // }
        // if (currentMonth === 9 || currentMonth === 10) {
        //     setStartingMonth(8);
        // }
        // if (currentMonth === 11 || currentMonth === 12) {
        //     setStartingMonth(10);
        // }


        // export function getNext6DaysFromDate(dateString) {
        //     const startDate = new Date(dateString);
        //     const days = [];
        //     // for (let i = 0; i < 7; i++) {
        //     for (let i = 0; i < 7; i++) {
        //       const nextDay = new Date(startDate);
        //       nextDay.setDate(startDate.getDate() + i);
        //       // Format the date as "YYYY-MM-DD"
        //       const formattedDate = nextDay.toISOString().split('T')[0];
        //       days.push(formattedDate);
        //     }
        //     return days;
        // }
        
        // export function getNext6DaysFromDateSkip(dateString) {
        //   const startDate = new Date(dateString);
        //   const days = [];
          
        //   for (let i = 0; days.length < 7; i++) {
        //     const nextDay = new Date(startDate);
        //     nextDay.setDate(startDate.getDate() + i);
        //     const formattedDate = nextDay.toISOString().split('T')[0];
        //     const divInvalidExists = document.querySelector(`div.fully-booked[data-date="${formattedDate}"]`);
            
        //     if (divInvalidExists) {
        //       // Skip the invalid date and continue with the next one
        //       continue;
        //     }
        //     days.push(formattedDate);
        //   }
        //   return days;
        // }